import React from "react"
import { graphql } from "gatsby"
import Pois from "../components/pois/page"

const FoodBeveragesPage = ({ data, location }) => {
  return <Pois title="Gastronomie" data={data} location={location} />
}

export const pageQuery = graphql`
  query FoodBeveragesQuery {
    site {
      siteMetadata {
        house
        title
      }
    }
    allContentfulPoi(
      filter: { type: { in: ["Café", "Restaurant", "Supermarkt"] } }
    ) {
      nodes {
        url
        title
        type
        location {
          lat
          lon
        }
        image {
          fluid(maxWidth: 1024, maxHeight: 768) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        body {
          childMarkdownRemark {
            excerpt
          }
        }
      }
    }
  }
`

export default FoodBeveragesPage
